import apiClient from './apiClient';

const useMockAuth = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_MOCK_AUTH === 'true';

const mockDashboardStats = () => ({
  agents: {
    total: 4,
    online: 3,
    offline: 1,
  },
  jobs: {
    total: 18,
    success: 14,
    failed: 2,
    running: 2,
  },
  schedules: {
    total: 6,
    active: 5,
  },
  packages: {
    total: 9,
    active: 7,
  },
  recentJobs: [
    {
      id: 'mock-job-1',
      name: 'Sincronizar conexões',
      status: 'success',
      time: new Date(Date.now() - 8 * 60 * 1000).toISOString(),
      successCount: 12,
      failedCount: 0,
    },
    {
      id: 'mock-job-2',
      name: 'Processar automações',
      status: 'running',
      time: new Date(Date.now() - 24 * 60 * 1000).toISOString(),
      successCount: 4,
      failedCount: 0,
    },
    {
      id: 'mock-job-3',
      name: 'Validar credenciais',
      status: 'failed',
      time: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      successCount: 1,
      failedCount: 1,
    },
  ],
});

export const getDashboardStats = async () => {
  if (useMockAuth) {
    return mockDashboardStats();
  }

  try {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    
    // Never return mock data - always throw errors to avoid fake data in production
    console.error('Dashboard stats API call failed:', error.response?.status, error.response?.data);
    throw new Error(error.response?.data?.detail || error.response?.data?.message || 'Failed to load dashboard data');
  }
};


export const getDashboardAnalytics = async (days = 30) => {
  if (useMockAuth) {
    return {
      days,
      jobs: [],
      success_rate: 0,
      average_duration: 0,
    };
  }

  try {
    const response = await apiClient.get('/analytics/dashboard', {
      params: { days }
    });
    return response.data;
  } catch (error) {
    // Error fetching dashboard analytics
    throw new Error(error.response?.data?.detail || 'Failed to load dashboard analytics');
  }
};
